import React, { useState } from "react";
import { ArrowPathIcon } from "@heroicons/react/24/solid";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { addCoupon } from "../../../redux/reducer/couponsReducer";

const AddCouponForm = ({ onClose }) => {
  const [couponCode, setCouponCode] = useState("");
  const [discountValue, setDiscountValue] = useState("");
  const [startAt, setStartAt] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [expiresAt, setExpiresAt] = useState("");
  const [numUsers, setNumUsers] = useState("");
  const [description, setDescription] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const [error, setError] = useState("");

  // const handleSubmit = () => {
  //   setIsLoading(true);
  //   setTimeout(() => {
  //     console.log({
  //       couponCode,
  //       discountValue,
  //       startDate,
  //       endDate,
  //       numUsers,
  //       notes,
  //     });

  //     setTimeout(() => {
  //       setIsLoading(false);
  //       onClose();
  //     }, 2000);
  //   }, 1000);
  // };
  // <style>
  //   {{}}
  const handleSubmit = async () => {
    if (couponCode.trim().length < 3) {
      setError("Coupon code must be at least 3 characters");
      return;
    } else {
      setError("");
    }

    if (!discountValue || !startAt || !expiresAt) {
      toast.error("Please fill all required fields");
      return;
    }

    const newCoupon = {
      code: couponCode,
      baseAmount: Number(discountValue),
      startAt,
      expiresAt,
      maxUsage: Number(numUsers) || 0,
      description,
    };

    try {
      setIsLoading(true);
      await dispatch(addCoupon(newCoupon)).unwrap();
      // alert("Coupon added successfully!");
      onClose();
    } catch (error) {
      console.error("Failed to add coupon:", error);
      toast.error(error?.message || "Failed to add coupon");
    } finally {
      setIsLoading(false);
    }
  };

  // </style>
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-[90%] sm:w-[50%] p-6 rounded-xl shadow-xl space-y-4">
        <h2 className="mb-4 text-xl font-bold text-gray-900">Add New Coupon</h2>

        {/* Coupon Code */}
        <div>
          <label className="block mb-1 text-sm font-medium text-gray-700">
            Coupon Code
          </label>
          <input
            type="text"
            placeholder="e.g. NEWYEAR50"
            value={couponCode}
            onChange={(e) => setCouponCode(e.target.value)}
            className="w-full px-3 py-2 text-gray-800 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-400 focus:outline-none"
          />
          {error && <p className="mt-1 text-sm text-red-500">{error}</p>}
        </div>

        {/* Discount Value (KWD) */}
        <div>
          <label className="block mb-1 text-sm font-medium text-gray-700">
            Discount Value (KWD)
          </label>
          <div className="flex items-center border border-gray-300 rounded-lg focus-within:ring-2 focus-within:ring-yellow-400">
            <input
              type="number"
              placeholder="e.g. 10"
              min="1"
              value={discountValue}
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || Number(value) > 0) {
                  setDiscountValue(value);
                }
              }}
              className="w-full px-3 py-2 text-gray-800 rounded-l-lg focus:outline-none 
      [-moz-appearance:textfield] 
      [&::-webkit-outer-spin-button]:appearance-none 
      [&::-webkit-inner-spin-button]:appearance-none"
            />
            <span className="px-3 py-2 text-gray-700 bg-gray-100 border-l border-gray-300 rounded-r-lg">
              KWD
            </span>
          </div>
        </div>

        {/* Start and End Date */}
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              Start Date
            </label>
            <input
              type="date"
              value={startAt}
              onChange={(e) => setStartAt(e.target.value)}
              className="w-full px-3 py-2 text-gray-800 transition border border-gray-300 rounded-lg cursor-pointer focus:ring-2 focus:ring-yellow-400 focus:outline-none bg-gray-50 hover:bg-gray-100"
            />
          </div>

          <div>
            <label className="block mb-1 text-sm font-medium text-gray-700">
              End Date
            </label>
            <input
              type="date"
              value={expiresAt}
              onChange={(e) => setExpiresAt(e.target.value)}
              className="w-full px-3 py-2 text-gray-800 transition border border-gray-300 rounded-lg cursor-pointer focus:ring-2 focus:ring-yellow-400 focus:outline-none bg-gray-50 hover:bg-gray-100"
            />
          </div>
        </div>

        {/* Number of Users */}
        <div>
          <label className="block mb-1 text-sm font-medium text-gray-700">
            Number of Users
          </label>
          <input
            type="number"
            placeholder="e.g. 100"
            min="1"
            value={numUsers}
            onChange={(e) => {
              const value = e.target.value;
              if (value === "" || Number(value) > 0) {
                setNumUsers(value);
              }
            }}
            className="w-full px-3 py-2 text-gray-800 border border-gray-300 rounded-lg 
  focus:ring-2 focus:ring-yellow-400 focus:outline-none
  [-moz-appearance:textfield]
  [&::-webkit-outer-spin-button]:appearance-none
  [&::-webkit-inner-spin-button]:appearance-none"
          />
        </div>

        {/* Description */}
        <div>
          <label className="block mb-1 text-sm font-medium text-gray-700">
            Notes
          </label>
          <textarea
            placeholder="Additional notes about the coupon..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            className="w-full px-3 py-2 text-gray-800 border border-gray-300 rounded-lg resize-none focus:ring-2 focus:ring-yellow-400 focus:outline-none bg-gray-50"
            rows={3}
          />
        </div>

        {/* Buttons */}
        <div className="flex justify-end gap-3 pt-4">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 transition bg-gray-200 rounded-lg hover:bg-gray-300"
          >
            Cancel
          </button>

          {isLoading ? (
            <ArrowPathIcon className="w-10 h-10 p-2 text-white bg-yellow-500 rounded-full animate-spin" />
          ) : (
            <button
              onClick={handleSubmit}
              className="px-5 py-2 text-sm font-semibold text-black transition rounded-lg bg-custom-yellow hover:bg-yellow-500"
            >
              Submit
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddCouponForm;
